import { render, staticRenderFns } from "./RectangleDragHandles.vue?vue&type=template&id=4608e5a2&scoped=true&"
import script from "./RectangleDragHandles.vue?vue&type=script&lang=ts&"
export * from "./RectangleDragHandles.vue?vue&type=script&lang=ts&"
import style0 from "./RectangleDragHandles.vue?vue&type=style&index=0&id=4608e5a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4608e5a2",
  null
  
)

export default component.exports